module.exports = __webpack_public_path__ + "img/ER.e08875ad.png";